/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmListDocumentsRequest {
    getFixupPrototypeFunction() { return AwsSsmListDocumentsRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmListDocumentsRequest>): AwsSsmListDocumentsRequest {
        let obj = Object.assign(new AwsSsmListDocumentsRequest(), model);
        AwsSsmListDocumentsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmListDocumentsRequest>): AwsSsmListDocumentsRequest {
        if (!model) return null;
        return AwsSsmListDocumentsRequest.newInstance(<AwsSsmListDocumentsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmListDocumentsRequest) {
        if (!obj) return;

        models.AwsSsmListDocumentsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmListDocumentsRequest): boolean {
        Object.setPrototypeOf(obj, AwsSsmListDocumentsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AwsSsmListDocumentsRequestContext.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AwsSsmListDocumentsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AwsSsmListDocumentsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AwsSsmListDocumentsRequestContext;

}
